import React, { Component } from 'react';
import { Loader } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
// import "react-table/react-table.css";
import { ajaxPost } from '../../ajax';
import DataGrid from 'react-data-grid';
import { TimeDisplayFormat } from '../../utils';

class DTRAdjustmentList extends Component {
  state = {
    Parameters: {
      CutoffId: "-1",
      needle: "",
      startingIndex: 0,
      itemCount: 20,
      totalPages: 1,
      advanceFilter: {
        companyIds: [],
        divisionIds: [],
        departmentIds: [],
        locationIds: [],
        costcenterIds:[],
        positionIds: []
      },
    },
    loading: false,
    initialLoad: true,
    ActivePage: 1,
    PageSize: 100,
    DTRAdjustment: [],

    gridHeight: window.innerHeight - 320,
  }
  constructor(props) {
    super(props);
    this.state.Parameters = this.props.Parameters;
    this.state.initialLoad = this.props.initialLoad;
    this.state.DTRAdjustment = this.props.DTRAdjustment;
    this._columns = [
      { key: 'EmployeeNumber', name: 'Employee Number', locked: true, width: 150, resizable: true },
      { key: 'Employee', name: 'Employee', locked: true, width: 150, resizable: true },
      { key: 'Modules', name: 'Transactions', width: 200, resizable: true },
      { key: 'RecordDate', name: 'RecordDate', width: 100 },
      { key: 'Absent', name: 'Absent', width: 100 },
      { key: 'HW', name: 'Reg Hours Work', width: 100 },
      { key: 'Late', name: 'Late', width: 100 },
      { key: 'UT', name: 'UT', width: 100 },
    ];
    this._columns.push({ key: 'TotalOT', name: 'Total OT', width: 150 });

    this._columns.push(
      { key: 'OT', name: 'Reg OT', width: 100 },
      { key: 'ND', name: 'ND', width: 100 },
      { key: 'NDOT', name: 'NDOT', width: 100 },
      { key: 'RD', name: 'RD', width: 100 },
      { key: 'RDOT', name: 'RDOT', width: 100 },
      { key: 'RDND', name: 'RDND', width: 100 },
      { key: 'RDNDOT', name: 'RDNDOT', width: 100 },
      { key: 'HD', name: 'HD', width: 100 },
      { key: 'HDOT', name: 'HDOT', width: 100 },
      { key: 'HDND', name: 'HDND', width: 100 },
      { key: 'HDNDOT', name: 'HDNDOT', width: 100 },
      { key: 'HDRD', name: 'HDRD', width: 100 },
      { key: 'HDRDOT', name: 'HDRDOT', width: 100 },
      { key: 'HDRDND', name: 'HDRDND', width: 100 },
      { key: 'HDRDNDOT', name: 'HDRDNDOT', width: 100 },
      { key: 'SD', name: 'SD', width: 100 },
      { key: 'SDOT', name: 'SDOT', width: 100 },
      { key: 'SDND', name: 'SDND', width: 100 },
      { key: 'SDNDOT', name: 'SDNDOT', width: 100 },
      { key: 'SDRD', name: 'SDRD', width: 100 },
      { key: 'SDRDOT', name: 'SDRDOT', width: 100 },
      { key: 'SDRDND', name: 'SDRDND', width: 100 },
      { key: 'SDRDNDOT', name: 'SDRDNDOT', width: 100 },
      { key: 'TotalOT', name: 'Total OT', width: 150 });
    // }
  }
  componentWillMount() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize = this.handleResize.bind(this);
    if (this.state.initialLoad === true) {
      var param = this.state.Parameters;
      this.onSearch(param);
    }
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }
  componentDidMount() {
    this.handleResize();
  }
  handleResize = () => {

    let headerMargin = 271;
    let footerMargin = 35;
    let gridTop = (document.getElementById("table")) == null ? 50 : (document.getElementById("table")).offsetTop;
    var gridHeight = window.innerHeight - (headerMargin + gridTop + footerMargin);
    this.setState({
      gridHeight,
    });
  }
  rowGetter = (i) => {
    return this.state.DTRAdjustment[i];
  };
  onSearch = (parameter) => {
    this.setState({ loading: true });
    this.LoadDTRAdjustments(data => {
      this.mapData(data.Content);
      var totalPages = data.Count / this.state.Parameters.itemCount;
      totalPages -= totalPages % 1;
      if (data.Count > totalPages * this.state.Parameters.itemCount) {
        totalPages++;
      }
      var parameters = this.state.Parameters;
      parameters.totalPages = totalPages;
      this.setState({
        loading: false,
        initialLoad: false,
        Parameters: parameters
      });
      this.props.updateState(this.state, "DTRAdjustmentList");
    }, parameter);
  }
  LoadDTRAdjustments = (callback, parameters, startIndex, itemCount) => {

    ajaxPost({
      url: 'api/Cutoff/LoadDTRAdjustment',
      data: {
        "Parameters": JSON.stringify(parameters)
      },
      onSuccess: data => {
        callback(data);
      },
      finally: () => { }
    })
  }
  mapData = (summaries) => {
    var SummaryViews = []
    summaries.forEach(sum => {
      var summary =
      {
        EmployeeNumber: sum.DTRAdjustment.EmployeeNumber,
        Employee: sum.DTRAdjustment.FullName,
        Modules: sum.ModuleDisplay,
        RecordDate: sum.FormattedDate,
        Absent: sum.DTRAdjustment.ABSENT,
        LWP: sum.DTRAdjustment.LEAVEWITHPAY,
        LWOP: sum.DTRAdjustment.LEAVEWITHOUTPAY,
        HW: TimeDisplayFormat(sum.DTRAdjustment.RH),
        Late: sum.DTRAdjustment.LATE,
        UT: TimeDisplayFormat(sum.DTRAdjustment.UNDERTIME),
        TotalOT: TimeDisplayFormat(sum.DTRAdjustment.TotalOT),
        OT: TimeDisplayFormat(sum.DTRAdjustment.OT),
        ND: TimeDisplayFormat(sum.DTRAdjustment.ND),
        NDOT: TimeDisplayFormat(sum.DTRAdjustment.NDOT),
        RD: TimeDisplayFormat(sum.DTRAdjustment.RD),
        RDOT: TimeDisplayFormat(sum.DTRAdjustment.RDOT),
        RDND: TimeDisplayFormat(sum.DTRAdjustment.RDND),
        RDNDOT: TimeDisplayFormat(sum.DTRAdjustment.RDNDOT),
        HD: TimeDisplayFormat(sum.DTRAdjustment.HD),
        HDOT: TimeDisplayFormat(sum.DTRAdjustment.HDOT),
        HDND: TimeDisplayFormat(sum.DTRAdjustment.HDND),
        HDNDOT: TimeDisplayFormat(sum.DTRAdjustment.HDNDOT),
        HDRD: TimeDisplayFormat(sum.DTRAdjustment.HDRD),
        HDRDOT: TimeDisplayFormat(sum.DTRAdjustment.HDRDOT),
        HDRDND: TimeDisplayFormat(sum.DTRAdjustment.HDRDND),
        HDRDNDOT: TimeDisplayFormat(sum.DTRAdjustment.HDRDNDOT),
        SD: TimeDisplayFormat(sum.DTRAdjustment.SD),
        SDOT: TimeDisplayFormat(sum.DTRAdjustment.SDOT),
        SDND: TimeDisplayFormat(sum.DTRAdjustment.SDND),
        SDNDOT: TimeDisplayFormat(sum.DTRAdjustment.SDNDOT),
        SDRD: TimeDisplayFormat(sum.DTRAdjustment.SDRD),
        SDRDOT: TimeDisplayFormat(sum.DTRAdjustment.SDRDOT),
        SDRDND: TimeDisplayFormat(sum.DTRAdjustment.SDRDND),
        SDRDNDOT: TimeDisplayFormat(sum.DTRAdjustment.SDRDNDOT)
      }
      SummaryViews.push(summary);

    });
    this.setState({ DTRAdjustment: SummaryViews });
  }
  handleChangePage = (event, page) => {
    const startIndex = page.activePage - 1;
    this.setState({ Page: startIndex });
    this.setState({ ActivePage: page.ActivePage });
  }
  render() {
    return (
      <div id='table'>
        <Loader active={this.state.loading} />
        <DataGrid
          columns={this._columns}
          rows={this.state.DTRAdjustment}
          rowsCount={this.state.DTRAdjustment.length}
          minHeight={this.state.gridHeight}
        />
      </div>
    );
  }
}
export default DTRAdjustmentList